import React from 'react'

export default function EyeContainIcon({ width = 21, height = 21, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_21119_187090)">
      <path d="M0.396484 11.4731C0.396484 11.4731 3.39648 4.47314 10.3965 4.47314C17.3965 4.47314 20.3965 11.4731 20.3965 11.4731C20.3965 11.4731 17.3965 18.4731 10.3965 18.4731C3.39648 18.4731 0.396484 11.4731 0.396484 11.4731Z" stroke="#B8C4FF" stroke-width="1.70305" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.66406 10.6641C7.66406 12.3198 9.00832 13.6641 10.6641 13.6641C12.3198 13.6641 13.6641 12.3198 13.6641 10.6641C13.6641 9.00832 12.3198 7.66406 10.6641 7.66406C9.00832 7.66406 7.66406 9.00832 7.66406 10.6641V10.6641" stroke="#B8C4FF" stroke-width="1.70305" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_21119_187090">
      <rect width="20.4366" height="20.4366" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  )
}
